import React from 'react'

const CustomButton = ({ textLoad, loading, onClick, className, children, isDisabled, ...props }) => {
    const buttonClassName = `
    flex items-center justify-center gap-2
    px-4 py-1.5
    rounded-md
    bg-cs-primary hover:bg-cs-primary-hover
    text-white text-sm font-medium
    border border-cs-primary-dark/40
    shadow-sm
    transition-all duration-200 ease-in-out
    focus:outline-none focus:ring-2 focus:ring-cs-primary/40
    active:scale-[0.98]
    mr-3 mb-2
    ${isDisabled ? 'opacity-50 cursor-not-allowed hover:bg-cs-primary' : ''}
    ${className}
  `

    return (
        <>
            {loading ? (
                <button
                    onClick={onClick}
                    className="
            flex items-center justify-center gap-2
            px-4 py-1.5
            rounded-md
            bg-cs-muted
            text-white text-sm font-medium
            border border-cs-border
            shadow-sm
            cursor-not-allowed
            mr-3 mb-2
          "
                    disabled
                    {...props}
                >
                    <svg
                        className="animate-spin h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                    </svg>
                    <span id="buttonText">{textLoad}...</span>
                </button>
            ) : (
                <button
                    onClick={onClick}
                    className={buttonClassName}
                    disabled={isDisabled}
                    {...props}
                >
                    {children}
                </button>
            )}
        </>
    )
}

export default CustomButton
